import { Component } from '@angular/core';
import {
    EventStatusFilterEnum,
    EventStatusFilterEnumLabelMap,
} from '../../../../models/events/event-status-filter.enum';
import { FiltersItem } from '../../../../models/shared/filters-item.model';
import { BaseFiltersCheckbox } from '../../../shared/base-filters-checkbox/base-filters-checkbox.directive';

@Component({
    selector: 'app-joined-events-done-checkbox',
    templateUrl: './joined-events-done-checkbox.component.html',
    providers: [{ provide: BaseFiltersCheckbox, useExisting: JoinedEventsDoneCheckboxComponent }],
})
export class JoinedEventsDoneCheckboxComponent extends BaseFiltersCheckbox {
    protected override createFilterItem(): FiltersItem {
        const value = EventStatusFilterEnum.IsDone;
        return new FiltersItem(
            `Joined.${EventStatusFilterEnum[value]}`,
            this.wtranslate.transform(EventStatusFilterEnumLabelMap[value], 'eventStatuses'),
        );
    }
}
